import { render, staticRenderFns } from "./Menciones.vue?vue&type=template&id=1673fee0&scoped=true"
import script from "./Menciones.vue?vue&type=script&lang=js"
export * from "./Menciones.vue?vue&type=script&lang=js"
import style0 from "./Menciones.vue?vue&type=style&index=0&id=1673fee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673fee0",
  null
  
)

export default component.exports